<template>
  <div class="live-item">
    <!-- 展示图片 -->
    <a
      :href="liveUrl(dateObject.baseInfo.courseId,dateObject.details[0])"
      v-query="`1003.2449.3001.7931.${this.index}`"
      target="_blank"
    >
      <div class="live-content-img" v-report="spmClick">
        <img :src="dateObject.baseInfo.cover" class="module-click" />
      </div>
    </a>
    <!-- 直播课详情 -->
    <div class="live-detailed">
      <SpmFunc
        :url="liveUrl(dateObject.baseInfo.courseId,dateObject.details[0])"
        spm="1003.2449.3001.7931"
        :index="index"
        :view="spmView"
        :report="spmClick"
      >
        <div class="live-detailed-content">
          <p class="live-detailed-title rowspan module-click">{{ dateObject.baseInfo.title }}</p>
          <p class="live-detailed-teacher">讲师：{{ dateObject.baseInfo.lecturerUsername }}</p>
          <p class="live-detailed-start_time">
            <i
              v-if="dateObject.details[dateObject.details.length-1].liveTime!=null"
            >开播时间：{{ dateObject.details[dateObject.details.length-1].liveTime | setTime}}</i>
            <span>社群</span>
          </p>

          <p class="live-detailed-people_num">
            <img class="title-icon" src="@/assets/imgs/student.png" />
            <span>{{dateObject.baseInfo.joinCount}}人报名</span>
          </p>
        </div>
      </SpmFunc>
      <!-- 更多视频按钮 -->
      <div class="live-detailed-button">
        <button
          class="live-class-detailed"
          @click="dateObject.details.length>1?openDetailed():windowOpen(liveUrl(dateObject.baseInfo.courseId,dateObject.details[0]))"
          :class="dateObject.details.length>1?'color277CCC':''"
        >
          {{dateObject.details.length>1?'课程安排':'观看回放'}}
          <img
            v-if="dateObject.details.length>1&&!detailedShow"
            src="@/assets/imgs/Course/Special/ic_down.png"
            alt="left"
          />
          <img
            v-else-if="dateObject.details.length>1&&detailedShow"
            src="@/assets/imgs/Course/Special/ic_top.png"
            alt="left"
          />

          <img
            v-if="dateObject.details.length==1"
            src="@/assets/imgs/Course/Special/ic_left.png"
            alt="down"
          />
        </button>
      </div>
      <!-- 课程列表 -->
      <div class="live-layout" v-if="detailedShow">
        <ul>
          <a
            :href="liveUrl(dateObject.baseInfo.courseId,dateObject.details[index])"
            v-query="`1003.2449.3001.7931.${this.index}`"
            target="_blank"
          >
            <li
              class="row-span"
              v-for="(item, index) in dateObject.details"
              :key="item.id"
              v-report="spmClick"
            >
              <i></i>
              Day{{ index +1 }}：{{item.title}}
            </li>
          </a>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
const liveStatuInfo = {
  // 等待直播
  LIVE_WAIT: 0,
  // 开播
  LIVE_ING: 1,
  // 关播
  LIVE_END: 2,
  // 直播删除
  LIVE_DELETE: 3,
};

import SpmFunc from "@/components/Base/SpmFunc.vue";

export default {
  components: {
    SpmFunc,
  },
  props: {
    dateObject: {
      type: Object,
    },
    index: {
      type: Number,
    },
  },
  computed: {
    spmView() {
      let temp = {
        spm: "1003.2449.3001.7931",
        dest: this.liveUrl(
          this.dateObject.baseInfo.courseId,
          this.dateObject.details[0]
        ),
        index: this.index,
      };
      return temp;
    },
    spmClick() {
      let temp = {
        spm: "1003.2449.3001.7931",
        dest: this.liveUrl(
          this.dateObject.baseInfo.courseId,
          this.dateObject.details[0]
        ),
        index: this.index,
      };
      return temp;
    },
  },
  data() {
    return {
      detailedShow: false,
    };
  },
  methods: {
    openDetailed() {
      this.detailedShow = !this.detailedShow;
    },
    liveUrl(courseId, catalogueInfo) {
      // 根据直播状态选择直链 或 拼接链接
      if (
        catalogueInfo.liveStatus <= liveStatuInfo.LIVE_END &&
        catalogueInfo.liveStatus !== null
      ) {
        return catalogueInfo.liveUrl;
      } else {
        return (
          "https://edu.csdn.net/live/" +
          courseId +
          "/" +
          catalogueInfo.catalogueId
        );
      }
    },
    windowOpen(url) {
      window.open(url);
    },
  },
  filters: {
    setTime(time) {
      let temp = new Date(time);
      let year = temp.getFullYear();
      let month =
        temp.getMonth() < 10 ? "0" + temp.getMonth() : temp.getMonth();
      let day = temp.getDate() < 10 ? "0" + temp.getDate() : temp.getDate();

      let hour = temp.getHours() < 10 ? "0" + temp.getHours() : temp.getHours();
      let min =
        temp.getMinutes() < 10 ? "0" + temp.getMinutes() : temp.getMinutes();
      let s =
        temp.getSeconds() < 10 ? "0" + temp.getSeconds() : temp.getSeconds();

      return year + "-" + month + "-" + day + " " + hour + ":" + min + ":" + s;
    },
  },
};
</script>

<style lang="less" scoped>
.live-item {
  display: flex;
  margin-bottom: 16px;

  .live-content-img {
    position: relative;
    width: 156px;
    height: 88px;
    background: #f5f6f7;
    border-radius: 2px;
    margin-right: 12px;

    img {
      width: 156px;
      height: 88px;
      border-radius: 2px;
      object-fit: cover;
    }
  }
  .live-detailed {
    position: relative;
    width: 598px;

    .live-detailed-content {
      position: relative;

      .live-detailed-title {
        width: 100%;
        font-weight: 500;
        color: #555666;
        line-height: 20px;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        margin: 4px 0;
      }
      .live-detailed-teacher {
        display: block;
        font-size: 12px;
        font-weight: 500;
        color: #222226;
        line-height: 16px;
        margin-bottom: 4px;
      }
      .live-detailed-start_time {
        font-size: 12px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #555666;
        line-height: 16px;

        i {
          margin-right: 12px;
          font-style: normal;
        }

        span {
          color: #999aaa;
        }
      }

      .live-detailed-people_num {
        font-size: 12px;
        font-weight: 400;
        color: #999aaa;
        line-height: 16px;
        margin-top: 8px;
        display: flex;
        align-items: center;

        img {
          margin-right: 4px;
          display: block;
          width: 12px;
          height: 12px;
          object-fit: cover;
        }
      }
    }
    .live-detailed-button {
      position: absolute;
      top: 68px;
      right: 0;
      width: 598px;
      display: flex;
      justify-content: right;

      button {
        display: flex;
        align-items: center;
        width: 64px;
        height: 24px;
        background: #ffffff;
        border: 0;
        font-size: 12px;
        font-weight: 400;
        color: #222226;
        line-height: 16px;

        img {
          width: 16px;
          height: 16px;
        }
      }
      .color277CCC {
        color: #277ccc;
      }
    }
    .live-layout {
      margin-top: 12px;
      padding: 16px;
      width: 598px;
      box-sizing: border-box;
      border-radius: 2px;
      border: 1px solid #f0f0f2;

      li + li {
        margin-top: 16px;
      }
      li {
        display: flex;
        align-items: center;
        list-style-type: none;
        font-size: 12px;
        font-weight: 400;
        color: #555666;
        line-height: 16px;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        cursor: pointer;

        i {
          display: inline-block;
          width: 12px;
          height: 12px;
          border: 1px solid #999aaa;
          border-radius: 50%;
          margin-right: 4px;
          box-sizing: border-box;
        }
      }
    }
  }

  @media screen and (max-width: 1440px) {
    .live-detailed {
      width: calc(~"100% - 168px") !important;
    }
  }
}
</style>